import { useMemo } from 'react';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { userService } from '../../../services/User/userService';
import { useBackendData } from '../../../services/useBackendData';

export const useUserDetails = (userId?: number, userData?: UserDetailsDto) => {
  const { data: user, isLoading } = useBackendData({
    queryKey: ['user', userId],
    queryFn: () => userService.fetchSingleUser(userId!),
    enabled: !userData && !!userId,
    initialData: userData,
  });

  const info = useMemo(() => (!!user ? `${user.firstName} ${user.lastName} (#${user.id})` : ''), [user]);

  return { user, isLoading, info };
};
